import { useNavigate } from "react-router-dom";
import { useSelectorApp } from "../../lib/redux";
import { useTranslationApp } from "../../lib/i18next";
import { useGlobalNotificationsListener } from "../../hooks/useGlobalNotificationsListener";
import { GLOBAL_ALERTS_BELL_ARIA } from "../../i18n/keysTranslations";
import { ROUTE_NOTIFICATIONS } from "../../utils/constants";
import GlobalAlertsBellButton from "./GlobalAlertsBellButton";

const GLOBAL_ALERTS_BELL_BUTTON_ID = "global-alerts-bell-button";

const GlobalAlertsInbox = () => {
  const { t } = useTranslationApp();
  const navigate = useNavigate();
  const globalAlerts = useSelectorApp(
    (state) => state.alerts?.globalAlerts || []
  );

  useGlobalNotificationsListener();

  const hasUnread = globalAlerts.some((alert) => !alert.isRead);

  const onOpenNotifications = () => {
    navigate(ROUTE_NOTIFICATIONS);
  };

  return (
    <GlobalAlertsBellButton
      id={GLOBAL_ALERTS_BELL_BUTTON_ID}
      hasUnread={hasUnread}
      onClick={onOpenNotifications}
      label={t(GLOBAL_ALERTS_BELL_ARIA)}
    />
  );
};

export default GlobalAlertsInbox;
